const validOrderStates = ['refunded', 'partially_refunded', 'cancelled']

export const isDisabledPendingRefundRow = (state) => {
  const isRefundedState = validOrderStates.includes(state)

  return isRefundedState
}

export const transformedPendingRefundState = (state) => {
  // in pending refunds we have to override all states which are not included in validOrderStates array to 'refund_pending'
  const transformedState = validOrderStates.includes(state)
    ? state
    : 'refund_pending'

  return transformedState
}
